import { Product } from "vamos/cockpit/model/odata/VamosModel";
import { doubleEquals } from "vamos/cockpit/util/NumberUtil";

export class ProductHandler {

    public static hasSameProperties(expecedProduct : Product, actualProduct : Product) : boolean {
        return expecedProduct.ArticleGuid === actualProduct.ArticleGuid
            && expecedProduct.CarrierGuid === actualProduct.CarrierGuid
            && expecedProduct.GeometryGuid === actualProduct.GeometryGuid
            && expecedProduct.InnerLaminationGuid === actualProduct.InnerLaminationGuid
            && expecedProduct.OuterLaminationGuid === actualProduct.OuterLaminationGuid
            && expecedProduct.SealColorGuid === actualProduct.SealColorGuid
            && expecedProduct.SealGuid === actualProduct.SealGuid
            && expecedProduct.AdditionalEquipmentGuid === actualProduct.AdditionalEquipmentGuid
            && expecedProduct.BaseUnitGuid === actualProduct.BaseUnitGuid
            && doubleEquals(expecedProduct.BaseAmount, actualProduct.BaseAmount, 0.0001);
    }
    public static countSameProperties(expecedProduct : Product, actualProduct : Product) : number {
        const comparisons = [
            expecedProduct.ArticleGuid === actualProduct.ArticleGuid,
            expecedProduct.CarrierGuid === actualProduct.CarrierGuid,
            expecedProduct.GeometryGuid === actualProduct.GeometryGuid,
            expecedProduct.InnerLaminationGuid === actualProduct.InnerLaminationGuid,
            expecedProduct.OuterLaminationGuid === actualProduct.OuterLaminationGuid,
            expecedProduct.SealColorGuid === actualProduct.SealColorGuid,
            expecedProduct.SealGuid === actualProduct.SealGuid,
            expecedProduct.AdditionalEquipmentGuid === actualProduct.AdditionalEquipmentGuid,
            expecedProduct.BaseUnitGuid === actualProduct.BaseUnitGuid,
            doubleEquals(expecedProduct.BaseAmount, actualProduct.BaseAmount, 0.0001)
        ];

        return comparisons.filter(Boolean).length;    }

}
